import { render, staticRenderFns } from "./TaskClosure.vue?vue&type=template&id=606dea2c&scoped=true"
import script from "./TaskClosure.vue?vue&type=script&lang=js"
export * from "./TaskClosure.vue?vue&type=script&lang=js"
import style0 from "./TaskClosure.vue?vue&type=style&index=0&id=606dea2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606dea2c",
  null
  
)

export default component.exports